import { allCountries, CountryCode } from '../models/countries'

export const isCountryCode = (c: string): c is CountryCode => c in allCountries

export const countryCodeToFlagEmoji = (countryCode: string) =>
  countryCode.toUpperCase().replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt(0)))
